import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaPills, FaArrowLeft, FaGift } from "react-icons/fa";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { CircularProgress } from "@mui/material";
import { API_URL } from "../../api";

function MedicineRewardItems() {
  const token = localStorage.getItem("token");
  const api = axios.create({
    baseURL: API_URL(),
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const medicineName = location.state?.name || "Medicine";

  const [unitItems, setUnitItems] = useState([]);
  const [unitLoading, setUnitLoading] = useState(false);
  const [openPoints, setOpenPoints] = useState(false);
  const [selectedUnitItem, setSelectedUnitItem] = useState(null);
  const [requiredPoints, setRequiredPoints] = useState("");

  useEffect(() => {
    getUnitItems();
  }, []);

  const getUnitItems = async () => {
    setUnitLoading(true);
    try {
      const res = await api.get(`wallet/medicine-lists/${id}`);
      setUnitItems(res.data?.list || res.data?.items || []);
    } catch (err) {
      setUnitItems([]);
      Swal.fire("Error", err?.response?.data?.message || err.message, "error");
    } finally {
      setUnitLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/rewards");
  };

  const handleOpenPoints = (item) => {
    setSelectedUnitItem(item);
    setRequiredPoints(item?.points ?? "");
    setOpenPoints(true);
  };

  const handleClosePoints = () => {
    setOpenPoints(false);
    setSelectedUnitItem(null);
  };

  const handleSavePoints = async () => {
    if (!selectedUnitItem) return;
    if (requiredPoints === "" || Number(requiredPoints) < 0) {
      Swal.fire("Warning", "Required Points is required", "warning");
      return;
    }
    try {
      await api.put("medicine-item", {
        id: selectedUnitItem._id,
        points: Number(requiredPoints),
      });
      Swal.fire({
        title: "Successful!",
        text: "Points Updated Successfully!",
        icon: "success",
        cancelButtonText: "Close",
      });
      handleClosePoints();
      getUnitItems();
    } catch (err) {
      Swal.fire("Error", err?.response?.data?.message || err.message, "error");
    }
  };

  return (
    <div className="App">
      <div className="wrapper">
        <div style={{ paddingBottom: "1.5rem" }}>
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <button className="btn btn-link p-0" onClick={handleBack}>
                        <FaArrowLeft />
                      </button>
                    </li>
                    <li className="breadcrumb-item active">
                      {medicineName} - Items
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">
                    <FaPills /> {medicineName} - Items
                  </h3>
                </div>

                <div className="card-body">
                  <table className="table">
                    <thead className="text-center bg-info">
                      <tr>
                        <th>No</th>
                        <th>Code</th>
                        <th>Name</th>
                        <th>Selling Price</th>
                        <th>Current Qty</th>
                        <th>Type</th>
                        <th>Points</th>
                        <th style={{ whiteSpace: "nowrap", width: "1%" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {unitLoading ? (
                        <tr>
                          <td colSpan={8} className="text-center py-4">
                            <CircularProgress />
                          </td>
                        </tr>
                      ) : unitItems.length > 0 ? (
                        unitItems.map((item, i) => (
                          <tr key={item._id || i}>
                            <td>{i + 1}</td>
                            <td>{item.code}</td>
                            <td>{item.medicineItemName}</td>
                            <td>
                              {(item.sellingPrice || 0).toLocaleString()}
                            </td>
                            <td>{item.currentQuantity}</td>
                            <td>{item.itemType}</td>
                            <td>{item.points ?? "-"}</td>
                            <td style={{ whiteSpace: "nowrap", width: "1%" }}>
                              <button
                                className="btn btn-success btn-sm"
                                onClick={() => handleOpenPoints(item)}
                              >
                                <FaGift /> Set Points
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={8} className="text-center">
                            {unitLoading ? "Loading items..." : "No items found"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Dialog open={openPoints} onClose={handleClosePoints} maxWidth="xs" fullWidth>
          <DialogTitle>
            <div className="modal-header bg-success">
              <h4 className="modal-title">
                Set Points - {selectedUnitItem?.medicineItemName}
              </h4>
              <button type="button" className="close" onClick={handleClosePoints}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="modal-body">
              <div class="form-group">
                <label>Required Points</label>
                <input
                  type="number"
                  className="form-control border-info"
                  min={0}
                  value={requiredPoints}
                  onChange={(e) => setRequiredPoints(e.target.value)}
                  placeholder="Enter points needed to redeem"
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <button className="btn btn-secondary" onClick={handleClosePoints}>
              Cancel
            </button>
            <button className="btn btn-success" onClick={handleSavePoints}>
              Save
            </button>
          </DialogActions>
        </Dialog>

        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    </div>
  );
}

export default MedicineRewardItems;
